import { EarnedBadge } from "@shared/models";

import { BadgeCardViewModel } from "../../Badges/buildBadgeCards";

/**
 * Phase 37 D6: maps a viewed profile's `EarnedBadge` to the FULL `BadgeCardViewModel` shape
 * `BadgeCard` expects, even though `BadgeCard` itself only reads a subset of it — `name`, `iconUrl`,
 * `earned`, `awardedAt`, `pointsToNext`, and `description` (not `rarity`, which the redesigned card no
 * longer renders at all) — this satisfies its existing prop type without touching this epic's
 * already-shipped, already-reviewed `BadgeCard.tsx`.
 *
 * `description` is always `null`: `EarnedBadge` carries no description at all (that only lives on
 * the badge-definitions catalog, which a strip deliberately does not fetch — phase-37 plan §0).
 * `pointsToNext` is always `null`: it's only meaningful for a *locked* badge's "next tier"
 * (overview-rebuild-pr3-plan.md "The caption line"), and a strip shows earned badges only. `earned`
 * is always `true` for the same reason.
 */
export const earnedBadgeToViewModel = (badge: EarnedBadge): BadgeCardViewModel => ({
  definitionId: badge.badge_definition_id,
  code: badge.code,
  name: badge.name,
  description: null,
  category: badge.category,
  rarity: badge.rarity,
  iconUrl: badge.icon_url,
  earned: true,
  awardedAt: badge.awarded_at,
  pointsToNext: null,
});
